import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./overline-heading.scss";

const OverlineHeading = ({ text, size, icon, className, ...props }) => {
  const classes = classNames(
    "overline-heading",
    {
      "overline-heading--large": size === "large",
    },
    className
  );

  return (
    <h3 className={classes} {...props}>
      <span className="overline-heading__title">
        {icon && icon({ className: "overline-heading__icon" })}
        {text}
      </span>
    </h3>
  );
};

OverlineHeading.propTypes = {
  /**
   * The component text
   */
  text: PropTypes.string.isRequired,
  /**
   * Sets the heading size
   */
  size: PropTypes.oneOf(["default", "large"]),
  /**
   * Additional Icon component
   */
  icon: PropTypes.func,
  /**
   * Custom className to add to the component
   */
  className: PropTypes.string,
};

export default OverlineHeading;
